
import PaymentStatusWidget from '@/core/components/PaymentStatusWidget.vue';
import StatusBadge from '@/core/components/StatusBadge.vue';
import { StatusBadgeStatus } from '@/core/enums/status-badge-status';
import { LoanDetails } from '@/loan/types/loan-details';
import { MONTH_MAP } from '@/util/constants/month-map';
import { UtilHelper } from '@/util/helper';
import { Component, Prop, Vue } from 'vue-property-decorator';

const TEST_ID = 'Kloans-LoanFullyPaidWidget';

@Component({
	components: {
		PaymentStatusWidget,
		StatusBadge,
	},
})
export default class LoanFullyPaidWidget extends Vue {
	public TEST_ID = TEST_ID;

	public formatDollar = UtilHelper.formatDollar;

	@Prop()
	public loanDetails!: LoanDetails;

	@Prop()
	public loanId!: string;

	public badgeStatus = StatusBadgeStatus.SUCCESS;

	get dueDate(): string {
		const date = new Date(this.loanDetails?.general?.paymentDueDate);
		const dayOfMonth = date.getDate();
		const monthNum = date.getMonth() + 1;
		const month = MONTH_MAP.get(monthNum);

		return `${month} ${dayOfMonth}`;
	}
}
